import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/Pagination.css';
import {Dropdown} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaTrashAlt, FaFileExport,FaEdit} from 'react-icons/fa'; //FaUpload
import axios from 'axios';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';

const ViewPriceHeads = () => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const AuthorizationToken = localStorage.getItem('token');
    const epicxTenantId = localStorage.getItem('epicxTenantId');
    console.log("epicxTenantId", epicxTenantId);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedItems, setSelectedItems] = useState([]);
    const [originalData, setOriginalData] = useState([]); 
       
    useEffect(() => {
        const fetchPriceHeads = async () => {
            if (!epicxTenantId) {
                console.error('Tenant ID is not provided');
                return;
            }
            try {
                const response = await axios.get(`${BASE_URL}/promoCode/api/priceHeads/${epicxTenantId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${AuthorizationToken}`,
                          },
                        }
                );
                console.log(response.data);  

                if (Array.isArray(response.data)) {
                    setData(response.data);
                    setOriginalData(response.data);
                } else if (response.data.priceHeads && Array.isArray(response.data.priceHeads)) {
                    setData(response.data.priceHeads);
                    setOriginalData(response.data.priceHeads);
                } else {
                    console.error('API response structure does not match expected array format:', response.data);
                    setData([]);
                    setOriginalData([]);
                }
            } catch (error) {
                console.error('Error fetching price heads data:', error);
            }
        };
    
        fetchPriceHeads();
    }, [epicxTenantId]);
    
    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
        setData((prevData) => {
            const sortedData = [...prevData].sort((a, b) => {
                if (a[key] < b[key]) {
                    return direction === 'asc' ? -1 : 1;
                }
                if (a[key] > b[key]) {
                    return direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
            return sortedData;
        });
    };

    const handleSearch = (value) => {
        setSearchTerm(value.toLowerCase());  // Update the search term to lowercase
    
        if (value.trim() === '') {
            setData(originalData);  // If search term is empty, reset data to originalData (show all data)
        } else {
            const filteredData = originalData.filter((item) =>
                Object.keys(item).some((key) =>
                    item[key].toString().toLowerCase().includes(value.toLowerCase())  // Perform case-insensitive search
                )
            );
            setData(filteredData);  // Set the filtered data
        }
    
        setCurrentPage(1);  // Reset the page to 1 after search
    };

    const handleSelectAll = () => {
        if (selectedItems.length === data.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(data.map(item => item._id));
        }
    };

    const handleSelectItem = (_id) => {
        if (selectedItems.includes(_id)) {
            setSelectedItems(selectedItems.filter(item => item !== _id));
        } else {
            setSelectedItems([...selectedItems, _id]);
        }
    };

    const handleDelete = async () => {
        if (selectedItems.length === 0) {
            toast.error('No items selected for deletion');
            return;
        }
    
        const confirmDelete = window.confirm('Are you sure you want to delete the selected items?');
        if (!confirmDelete) {
            toast.info('Deletion canceled');
            return;
        }
    
        try {
            const deleteRequests = selectedItems.map(id =>
                axios.put(`${BASE_URL}/promoCode/api/priceHeads/${epicxTenantId}/delete/${id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${AuthorizationToken}`,
                          },
                        }
                )
            );
            await Promise.all(deleteRequests);
            const response = await axios.get(`${BASE_URL}/promoCode/api/priceHeads/${epicxTenantId}`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthorizationToken}`,
                      },
                    }
            );
            const updatedData = response.data && Array.isArray(response.data.priceHeads)
                ? response.data.priceHeads
                : [];
            setData(updatedData);
            setSelectedItems([]);
            toast.success('Items deleted successfully');
            window.location.reload();
        } catch (error) {
            console.error('Error deleting  price heads:', error);
            toast.error('Error deleting items');
        }
    };
    
    const handleEdit = () => {
        if (selectedItems.length === 1) {
            const [selectedId] = selectedItems; 
            navigate(`/updatePriceHeads/${selectedId}`); 
        } else {
            toast.error("Please select exactly one price heads to edit");
        }
    };
    const handleExport = () => {
        const dataToExport = selectedItems.length > 0 
            ? data.filter(item => selectedItems.includes(item._id)) 
            : data;
        const exportData = dataToExport.map(item => ({
            priceHeadsName: item.priceHeadsName,
            priceHeadsType: item.priceHeadsType,
            priceHeadsValue: item.priceHeadsValue,
            priority: item.priority,
            applicableCategories: item.applicableCategories,
            effectiveDate: item.effectiveDate,
            expirationDate: item.expirationDate,
            ActiveorDeactivatePriceHeads: item.ActiveorDeactivatePriceHeads,
            priceHeadDescription: item.priceHeadDescription,
            createdAt: item.createdAt,
            updatedAt:item.updatedAt

        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "PriceHeads");
        XLSX.writeFile(wb, 'PriceHeads_data.xlsx');
    };
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = Array.isArray(data) ? data.slice(indexOfFirstItem, indexOfLastItem) : [];
    const totalPages = Math.ceil(data.length / itemsPerPage);

    return (
        <>
            <Sidebar />
            <div style={{ height: '92vh', overflowY: 'auto', width: '100%' }}>
                <div style={{ padding: '15px' }}>
                    <div className='d-flex justify-content-between mb-3 align-items-center'>
                        <h4 className='mb-0'>Price Heads List</h4>
                        <div className='d-flex align-items-center'>
                            <div className='me-3'>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search..."
                                    style={{ borderRadius: '300px' }}
                                    value={searchTerm}
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                            </div>
                            <button
                                className="btn me-3"
                                style={{ backgroundColor: '#31a87e', color: 'white' }}
                                onClick={() => navigate(`/addpriceheads/${epicxTenantId}`)}
                            >
                                <FaPlus className="me-2" /> Add Price Heads
                            </button>
                            <Dropdown>
                                <Dropdown.Toggle 
                                    className="btn"
                                    style={{ backgroundColor: '#31a87e', color: 'white', border: 'none' }}
                                >
                                    Action
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {/* <Dropdown.Item>
                                        <FaUpload className="me-2" /> Push to all
                                    </Dropdown.Item> */}
                                    <Dropdown.Item onClick={handleDelete}
                                    disabled={selectedItems.length === 0}>
                                        <FaTrashAlt className="me-2" /> Delete
                                    </Dropdown.Item>
                                    <Dropdown.Item 
                                     onClick={handleEdit} 
                                    disabled={selectedItems.length !== 1}>
                                    <FaEdit className="me-2" /> Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={handleExport}>
                                        <FaFileExport className="me-2" /> Export
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header" style={{ height: '65px' }}>
                            <div>
                                <input
                                    type="checkbox"
                                    checked={selectedItems.length === data.length}
                                    onChange={handleSelectAll}
                                />
                            </div>
                            {['priceHeadsName', 'priceHeadsType', 'priceHeadsValue', 'effectiveDate', 'expirationDate'].map((key) => (
                                <div key={key} onClick={() => handleSort(key)}>
                                    {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                                    {sortConfig.key === key ? (sortConfig.direction === 'asc' ? ' ▲' : ' ▼') : ''}
                                </div>
                            ))}
                        </div>
                        <div className="card-body table-card-body" style={{ height: '395px' }}>
                            {currentData.map((item) => (
                                <div
                                    key={item._id}
                                    className={`row ${selectedItems.includes(item._id) ? 'selected-row' : ''}`}
                                >
                                    <div>
                                        <input
                                            type="checkbox"
                                            checked={selectedItems.includes(item._id)}
                                            onChange={() => handleSelectItem(item._id)}
                                        />
                                    </div>
                                    <div>{item.priceHeadsName}</div>
                                    <div>{item.priceHeadsType}</div>
                                    <div>{item.priceHeadsValue}</div>
                                    <div>{new Date(item.effectiveDate).toLocaleDateString()}</div>
                                    <div>{new Date(item.expirationDate).toLocaleDateString()}</div>
                                </div>
                            ))}
                        </div>
                        <div className="card-footer">
                            <div className="d-flex justify-content-between align-items-center">
                                <span style={{ marginRight: '10px', fontSize: '14px', fontWeight: '' }}>
                                    {`Total Price Heads: ${data.length}`}
                                </span>
                                <div className="pagination d-flex justify-content-center align-items-center">
                                    <nav>
                                        <ul className="pagination mb-0">
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link btn-sm"
                                                    onClick={() => setCurrentPage(1)}
                                                    style={{
                                                        borderColor: '#31a87e',
                                                        backgroundColor: 'white',
                                                        color: '#31a87e',
                                                        padding: '5px 10px',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    &laquo; 
                                                </button>
                                            </li>
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link btn-sm"
                                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                    style={{
                                                        borderColor: '#31a87e',
                                                        backgroundColor: 'white',
                                                        color: '#31a87e',
                                                        padding: '5px 10px',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    &lt;
                                                </button>
                                            </li>
                                            <li className="page-item active">
                                                <button
                                                    className="page-link btn-sm"
                                                    style={{
                                                        backgroundColor: '#31a87e',
                                                        color: 'white',
                                                        borderColor: '#31a87e',
                                                        padding: '5px 10px',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    {currentPage}
                                                </button>
                                            </li>
                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link btn-sm"
                                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                                    style={{
                                                        borderColor: '#31a87e',
                                                        backgroundColor: 'white',
                                                        color: '#31a87e',
                                                        padding: '5px 10px',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    &gt; 
                                                </button>
                                            </li>
                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link btn-sm"
                                                    onClick={() => setCurrentPage(totalPages)}
                                                    style={{
                                                        borderColor: '#31a87e',
                                                        backgroundColor: 'white',
                                                        color: '#31a87e',
                                                        padding: '5px 10px',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    &raquo; 
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{marginTop:'2%'}}>
                   <Footer />
                </div>
                
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={true}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    style={{ zIndex: 9999 }} 
                />
            </div>
        </>
    );
};

export default ViewPriceHeads